<section class="download-page" [ngSwitch]="info?.status">
    <ng-container *ngSwitchCase="'READY'">
        <h1>Dit hi-res foto</h1>
        <p>Link'et virker en gang (hvis download fejler kan du prøve igen inden for 10 minutter)</p>
        <a class="download" [href]="fileUrl" download>Download hi-res foto</a>
    </ng-container>
    <ng-container *ngSwitchCase="'USED'">
        <h1>Link'et er allerede brugt</h1>
        <p>Billedet er allerede download'et - skriv hvis du mener det er en fejl.</p>
    </ng-container>
    <ng-container *ngSwitchCase="'EXPIRED'">
        <h1>Link'et er forældet</h1>
        <p>Skriv/send din MobilePay kvittering så får du et nyt link.</p>
    </ng-container>
    <ng-container *ngSwitchCase="'NOT_FOUND'">
        <h1>Ugyldigt link</h1>
        <p>Check link, evt. kopier fra email</p>
    </ng-container>
    <p *ngSwitchDefault>Checker link...</p>
    <a routerLink="/">Tilbage</a>
</section>
